<template>
  <modal
    id="modalTurma"
    :exibir="exibir"
    :titulo="form?.id ? 'Editar turma' : 'Cadastrar turma'"
    :campos="$refs"
    :tamanho="'xl'"
    @fechar="fecharModal"
  >
    <div>
      <div class="d-flex justify-content-between mb-4">
        <div>
          <p class="titulo-medio">Dados de cadastro:</p>
        </div>
        <div v-if="form.id">
          <b-button @click="$emit('nova-turma')" variant="primary" class="mr-2">
            {{ $t('ACADEMICO.CADASTRAR_TURMA') }}
          </b-button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <input-text
            v-model="form.descricao"
            :label="$t('ACADEMICO.NOME')"
            :placeholder="$t('ACADEMICO.NOME')"
            type="text"
            :maxLength="50"
            ref="nome"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            type="number"
            v-model="form.cargaHoraria"
            :label="$t('ACADEMICO.CARGA_HORARIA')"
            :placeholder="$t('ACADEMICO.CARGA_HORARIA')"
            :min="1"
            :maxLength="6"
            ref="cargaHoraria"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            type="number"
            v-model="form.vagas"
            :label="$t('ACADEMICO.VAGAS')"
            :placeholder="$t('ACADEMICO.VAGAS')"
            :min="1"
            :maxLength="6"
            ref="vaga"
            required
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between mb-4">
      <div>
        <p class="titulo-medio">Adicione disciplinas à turma:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <input-select-search
          ref="disciplina"
          v-model="novaDisciplina.disciplinaId"
          :label="'Disciplina'"
          :options="opcoesDisciplinasFormated"
          required
        />
      </div>
      <div class="col-md-3">
        <input-select-search
          ref="media"
          v-model="novaDisciplina.tipoMediaEnum"
          :label="'Média'"
          :options="opcoesMedia"
          required
        />
      </div>
      <div class="col-md-3">
        <input-text
          type="number"
          ref="cargaHoraria"
          v-model="novaDisciplina.cargaHoraria"
          :label="'Carga Horária'"
          :min="1"
          required
        />
      </div>
      <div class="col-md-3 alinhamento-botao">
        <b-button variant="primary" @click="adicionar">Adicionar</b-button>
      </div>
      <!-- <tabela-disciplina :items="form.disciplinas" @remover="remover" /> -->
      <b-table
        :items="form.disciplinas"
        :fields="colunasDisciplina"
        show-empty
        :empty-text="$t('GERAL.NENHUM_REGISTRO')"
        head-variant="light"
        responsive
        striped
        hover
      >
        <template #cell(acoes)="item">
          <b-dropdown variant="outline-default">
            <b-dropdown-item @click="removerDisciplina(item)" v-if="podeExcluir">
              {{ $t('GERAL.EXCLUIR') }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvarFormulario">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

import TurmasService from '@/common/services/academico/turma.service.js';
import DisciplinasService from '@/common/services/academico/disciplinas.service.js';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';
import Permissoes from '@/components/mixins/permissoes';

import { InputSelectSearch, InputText } from '@/components/inputs';
import Modal from '@/components/modal/Modal';

export default {
  mixins: [Permissoes],
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
    filtro: { type: Object, default: Object },
  },
  components: {
    Modal,
    InputSelectSearch,
    InputText,
  },
  data() {
    return {
      refs: [],
      opcoesDisciplinas: [],
      opcoesMedia: [],
      novaDisciplina: {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
      },
      colunasDisciplina: [
        {
          key: 'codigo',
          label: 'Disciplina',
          sortable: true,
        },
        {
          key: 'disciplinaDescricao',
          label: 'Descrição',
          sortable: true,
        },
        {
          key: 'tipoMediaEnumDescricao',
          label: 'Média',
          sortable: true,
        },
        {
          key: 'cargaHoraria',
          label: 'Carga horária',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ]
    };
  },
  computed: {
    opcoesDisciplinasFormated() {
      return this.opcoesDisciplinas.filter(i => {
        return !this.form.disciplinas.find(disciplina => i.id == disciplina.disciplinaId)
      });
    }
  },
  mounted() {
    this.getdisciplina();
    this.getTipoMedia();
  },
  methods: {
    adicionar() {
      if (!this.validarFormulario()) return;
      helpers.resetarValidacao(this.$refs);

      if (!this.form.id) {
        this.adicionarDisciplinaLocalmente();
        return;
      }

      this.adicionarDisciplinaBackend();

      this.$emit('')

      this.novaDisciplina = {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
      };
    },

    adicionarDisciplinaLocalmente() {
      const mediaDescricao = this.opcoesMedia.filter(
        ({ id }) => id === this.novaDisciplina.tipoMediaEnum
      );

      this.novaDisciplina.tipoMediaEnumDescricao = mediaDescricao[0].descricao;

      const disciplinaDescricao = this.opcoesDisciplinas.filter(
        ({ id }) => id === this.novaDisciplina.disciplinaId
      );

      this.novaDisciplina.disciplinaDescricao = disciplinaDescricao[0].descricao;
      this.novaDisciplina.codigo = disciplinaDescricao[0].codigo;
      this.form.disciplinas.push(this.novaDisciplina);

      this.getdisciplina();

      this.novaDisciplina = {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
      };
    },

    adicionarDisciplinaBackend() {
      this.$store.dispatch(START_LOADING);
      DisciplinasService
        .criarTurmaDisciplina({ ...this.novaDisciplina, turmaId: this.form.id })
        .then(({ data }) => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Disciplina criada com sucesso')
          );

          this.form.disciplinas = data;
          this.getdisciplina();

          this.form.novaDisciplina = {
            disciplinaId: '',
            tipoMediaEnum: '',
            cargaHoraria: '',
          };
        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    removerDisciplina(item) {
      mensagem
        .confirmacao(null, this.$t('Deseja remover disciplina ?'))
        .then(async (result) => {
          if (result.value) {
            if (item.item.id) {
              this.removerDisciplinaBackend(item);
              return;
            }
            this.form.disciplinas.splice(item.index, 1);
            this.getdisciplina();
          }
        });
    },

    removerDisciplinaBackend(item) {
      this.$store.dispatch(START_LOADING);
      DisciplinasService
        .excluirTurmaDisciplina({ id: item.item.id, turmaId: this.form.id })
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Disciplina removida com sucesso')
          );
          this.form.disciplinas.splice(item.index, 1);
          this.getdisciplina();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getTipoMedia() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-media')
        .then(({ data }) => {
          this.opcoesMedia = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getdisciplina() {
      this.$store.dispatch(START_LOADING);
      DisciplinasService.listar()
        .then(({ data }) => {
          this.opcoesDisciplinas = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // --------------------------------------------------------
    salvarFormulario() {
      if (this.form?.id) return this.atualizarTurma();

      this.form.cursoId = this.filtro.cursoId;
      this.form.grupoTurmaId = this.filtro.grupoTurmaId;

      this.criarTurma();
    },
    criarTurma() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      TurmasService.criar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO.TURMA_CADASTRADA')
          );
          this.$emit('atualiza-tabela');
          this.$emit('fechar');
        })
        .catch((err) => {
          mensagem.showErrors(err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    atualizarTurma() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      TurmasService.editar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO.TURMA_EDITADA')
          );
          this.$emit('atualiza-tabela');
          this.$emit('fechar');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    fecharModal() {
      this.$emit('fechar');
    },
    validarFormulario() {
      const totalCargaHoraria = this.form.disciplinas
        .map((disciplina) => parseInt(disciplina.cargaHoraria))
        .reduce((acc, cargaHoraria) => acc + cargaHoraria, 0);
      if (totalCargaHoraria > this.form.cargaHoraria) {
        mensagem.erro(
          this.$t('GERAL.ERRO'),
          this.$t(
            'A soma da Carga Horária das disciplinas está maior que a Carga Horária da turma'
          )
        );
        return;
      }
      return helpers.validarFormulario(this.refs);
    },
  },
};
</script>

<style>
.alinhamento-botao {
  padding-top: 28px;
}
</style>
